"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _BaseSubscriptionService = _interopRequireDefault(require("./BaseSubscriptionService"));
var _alphapointApexApi = require("alphapoint-apex-api");
var _apex = _interopRequireDefault(require("../../apex"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Level2SubscriptionService = /*#__PURE__*/function (_BaseSubscriptionServ) {
  function Level2SubscriptionService() {
    _classCallCheck(this, Level2SubscriptionService);
    return _callSuper(this, Level2SubscriptionService, arguments);
  }
  _inherits(Level2SubscriptionService, _BaseSubscriptionServ);
  return _createClass(Level2SubscriptionService, [{
    key: "initSubscription",
    value: function initSubscription(instrumentId) {
      var _this = this;
      if (this.subscription || this.initializedInstrumentId) {
        this.stop();
      }
      return _apex["default"].connection.RPCPromise('SubscribeLevel2', {
        OMSId: 1,
        instrumentId: instrumentId,
        depth: 250
      }).then(function (res) {
        var data = JSON.parse(res.o);
        if (data.result !== false) {
          _this.initializedInstrumentId = instrumentId;
          return data.map(function (x) {
            return new _alphapointApexApi.Level2(x);
          });
        }
        throw data;
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      this.unsubscribe();
      this.subscription = _apex["default"].connection.ws.filter(function (x) {
        return x.n === 'Level2UpdateEvent';
      }).subscribe(function (response) {
        var data = JSON.parse(response.o);
        var updates = data.map(function (x) {
          return new _alphapointApexApi.Level2(x);
        });
        callback(updates);
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.initializedInstrumentId) {
        this.stopOne(this.initializedInstrumentId);
      }
    }
  }, {
    key: "stopOne",
    value: function stopOne(instrumentId) {
      _apex["default"].connection.unsubscribeLevel2(instrumentId);
      this.initializedInstrumentId = null;
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this.subscription) {
        this.subscription.unsubscribe();
        this.subscription = null;
      }
    }
  }, {
    key: "isInitialized",
    value: function isInitialized(instrumentId) {
      return this.initializedInstrumentId === instrumentId || !!this.subscription;
    }
  }]);
}(_BaseSubscriptionService["default"]);
var _default = exports["default"] = new Level2SubscriptionService();